import { TabContext, TabList, TabPanel } from '@mui/lab'
import { Box, Container, Tab, Typography } from '@mui/material'
import { t } from 'i18next'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import AutomationActionsList from './Lists/ActionsList.jsx'
import AutomationRulesList from './Lists/RulesList.jsx'
import AutomationTriggersList from './Lists/TriggersList.jsx'

const Automations = () => {
  const { tab } = useParams()
  const [activeTab, setActiveTab] = useState('rules')

  const handleChange = (_event, value) => setActiveTab(value)

  useEffect(() => {
    if (!tab) return
    setActiveTab(tab)
  }, [tab])

  return (
    <Container
      maxWidth="lg"
      sx={{ py: 3 }}
    >
      <Typography variant="h2">{t('common.automations')}</Typography>

      <TabContext value={activeTab}>
        <Box sx={{
          marginTop: 4,
          borderBottom: 1,
          borderColor: 'divider'
        }}>
          <TabList
            onChange={handleChange}
            aria-label={`${t('common.automations')}`}
          >
            <Tab
              aria-label={`${t('automations.rules')}`}
              label={t('automations.rules')}
              value="rules"
              data-testid="rules"
            />
            <Tab
              aria-label="triggers"
              label={t('automations.triggers')}
              value="triggers"
              data-testid="triggers"
            />
            <Tab
              aria-label={t('automations.actions')}
              label={t('automations.actions')}
              value="actions"
              data-testid="actions"
            />
          </TabList>
        </Box>
        <TabPanel
          value="rules"
          sx={{ px: 0 }}
        >
          {<AutomationRulesList />}
        </TabPanel>
        <TabPanel
          value="triggers"
          sx={{ px: 0 }}
        >
          {<AutomationTriggersList />}
        </TabPanel>
        <TabPanel
          value="actions"
          sx={{ px: 0 }}
        >
          {<AutomationActionsList />}
        </TabPanel>
      </TabContext>
    </Container>
  )
}

export default Automations
